export default __webpack_public_path__ + "static/media/FONDO_GARBANZO.a9abd614.jpg";